import { Button, Card, Col, Form, Input, message, Modal, Row, Spin } from 'antd';
import React from 'react';
import ZTable, {  ITableRef, IColumnType } from '@/components/ZTable';
import { useTranslation } from 'react-i18next';
import { ModalWidth, ROW_GUTTER, VALIDATE_REQUIRED } from '@/config';
import { clearAllTripGroupsCache } from '@/hooks/data/masterDataHook';
import { BusInsuranceDto, TripGroupModel } from '@/__generated';
import { apiSdk } from '@/httpClient';

type Props = {
  onClose: () => void;
};

const columns: IColumnType<BusInsuranceDto>[] = [
  {
    title: 'tripsPage_TripGroupName',
    dataIndex: 'name',
    ellipsis: true,
    sorter: true,
  },
];

export default function TripGroupsModal({ onClose }: Props) {
  const { t } = useTranslation();
  const zTb = React.useRef<ITableRef>();
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const clearCache = () => {
    clearAllTripGroupsCache();
  };
  const onFormSumit = (values: any) => {
    setLoading(true);
    apiSdk.TripGroupService.create({
      body: { ...values },
    })
      .then(response => {
        if (response?.success) {
          zTb.current?.reload();
          form.resetFields();
          clearCache();
        } else {
          if (response.message) {
            message.error(t(response.message || ''));
          }
        }
      })
      .catch(error => {
        message.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      style={{ top: 10 }}
      open={true}
      maskClosable={false}
      width={ModalWidth.medium}
      className="nta-custom-form"
      title={t('tripsPage_TripGroups')}
      forceRender={true}
      okText={t('save')}
      cancelText={t('Close')}
      okButtonProps={{ style: { display: 'none' } }}
      onCancel={onClose}
    >
      <Spin spinning={loading}>
        <Card className="mtopo-card" size="small" title={t('tripsPage_CreateTripGroup')}>
          <Form form={form} layout="vertical" onFinish={onFormSumit}>
            <Row gutter={ROW_GUTTER}>
              <Col md={12}>
                <Form.Item label={t('tripsPage_TripGroupName')} name="name" rules={[{ required: true, message: VALIDATE_REQUIRED }]}>
                  <Input />
                </Form.Item>
              </Col>

              <Col md={12}>
                <Form.Item label="  ">
                  <Button type="primary" htmlType="submit">
                    {t('save')}
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
      </Spin>
      <Card className="mtopo-card" size="small" title={t('tripsPage_TripGroups')}>
        <ZTable<TripGroupModel>
          hideHeader
          columns={columns}
          primaryKey="id"
          tableRef={zTb}
          url="/fleets/trip-groups/get-autocompletion-list"
          bordered
          transformDataSource={d => ({ data: d })}
          order_by="name"
          order_by_asc={true}
          allowEdit={false}
          allowDelete={false}
        ></ZTable>
      </Card>
    </Modal>
  );
}
